"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SubContextMenuContainer = /** @class */ (function (_super) {
    __extends(SubContextMenuContainer, _super);
    function SubContextMenuContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { top: "-" + Number.MAX_VALUE + "px", left: '0' };
        return _this;
    }
    SubContextMenuContainer.prototype.render = function () {
        var _this = this;
        var contextMenu = this.props.contextMenu;
        var renderedContextMenu = contextMenu.render(contextMenu.data, this.props.closeContextMenu);
        return React.createElement("nav", { className: "drop-menu", style: {
                overflow: "auto",
                position: "absolute",
                display: 'block',
                maxHeight: this.state.maxHeight,
                top: this.state.top,
                left: this.state.left
            }, ref: function (node) { _this.navElement = node; }, role: "menu" }, renderedContextMenu);
    };
    SubContextMenuContainer.prototype.componentDidMount = function () {
        var position = this.positionMenu();
        if (position)
            this.setState({ top: position.top, left: position.left, maxHeight: position.maxHeight });
    };
    SubContextMenuContainer.prototype.positionMenu = function () {
        if (!this.navElement)
            return;
        var relativeElement = document.getElementById(this.props.contextMenu.subContextMenuItemId);
        if (!relativeElement)
            return;
        var relativeRect = relativeElement.getBoundingClientRect();
        var elementRect = this.navElement.getBoundingClientRect();
        var top = this.getTop(relativeRect, elementRect);
        var left = this.getLeft(relativeRect, elementRect);
        var dropShadowHeight = 20;
        var maxHeight = window.innerHeight - dropShadowHeight;
        return {
            top: top + "px",
            left: left + "px",
            maxHeight: maxHeight + "px"
        };
    };
    SubContextMenuContainer.prototype.getTop = function (relativeRect, elementRect) {
        //Case 1: It fits entirely below it's parent.
        if (relativeRect.top + elementRect.height < window.innerHeight)
            return 0;
        var gap = (relativeRect.top + elementRect.height) - window.innerHeight;
        //Case 2: It will not fit even if slid up so give it the top of the window.
        if (gap > relativeRect.top)
            return -1 * relativeRect.top;
        //Case 3: It will fit if slid up the distance of overhang.
        return -1 * (gap);
    };
    SubContextMenuContainer.prototype.getLeft = function (relativeRect, elementRect) {
        var hasRoomToAlignToTheRightOfRelativeElement = relativeRect.right + elementRect.width < window.innerWidth;
        var hasRoomToAlignToTheLeftOfRelativeElement = relativeRect.left - elementRect.width > 0;
        var leftPxIfAligningToRight = relativeRect.width;
        var leftPxIfAligningToLeft = -1 * elementRect.width;
        if (hasRoomToAlignToTheRightOfRelativeElement)
            return leftPxIfAligningToRight;
        else if (hasRoomToAlignToTheLeftOfRelativeElement)
            return leftPxIfAligningToLeft;
        else
            return leftPxIfAligningToRight;
    };
    return SubContextMenuContainer;
}(React.Component));
exports.SubContextMenuContainer = SubContextMenuContainer;
